"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_1 = require("@icr-ui/theme");
const react_1 = require("react");
const button_1 = require("../button");
const flexbox_1 = require("../flexbox");
const typography_1 = require("../typography");
const styles_1 = require("./styles");
const MutationLoader = (0, react_1.forwardRef)(({ label, buttonProps, fullScreen = false, percent = 0 }, ref) => {
    return ((0, jsx_runtime_1.jsx)(flexbox_1.Flexbox, { fullScreen: fullScreen, fullWidth: true, alignItems: "flex-start", customStyles: {
            position: 'absolute',
            zIndex: 9999,
            top: 0,
            left: 0,
            backgroundColor: fullScreen ? 'rgba(255, 255, 255, 0.5)' : 'transparent',
        }, children: (0, jsx_runtime_1.jsx)(styles_1.StyledMutationLoaderWrapper, { ...{ percent, ref }, alignItems: "center", justifyContent: "center", children: (0, jsx_runtime_1.jsxs)(styles_1.StyledMutationLoader, { fullWidth: true, flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "24px", children: [(0, jsx_runtime_1.jsx)(typography_1.Typography, { colorScheme: { type: 'text', color: 'inverted' }, variant: "body", size: "lead", children: label }), (0, jsx_runtime_1.jsx)(button_1.Button, { small: true, variant: "outlined", onClick: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick, customStyles: {
                            color: theme_1.grayScale[50],
                            borderColor: theme_1.grayScale[50],
                            marginLeft: 'auto',
                            display: 'block',
                        }, children: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.label })] }) }) }));
});
MutationLoader.displayName = 'MutationLoader';
exports.default = MutationLoader;
//# sourceMappingURL=mutation-loader.js.map